import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-72708742"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "actor-warp"
};
const _hoisted_2 = {
  class: "table-warp cms-card-block"
};
const _hoisted_3 = {
  class: "mg-t--10",
  style: {
    "color": "#f02323"
  }
};
import { elMessage } from '@/utils';
import { clearData } from '@/utils/tools';
import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig';
import { formValidator, messageBox, validatorNonNull } from '@/utils/validate';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { getTerminalCheckApi, addTerminalCheckApi, editTerminalCheckApi, deleteTerminalCheckApi, switchStatusApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const formRef = ref(null);
    const searchConfig = reactive({
      formList: [{
        label: '关键字筛选',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }],
      formData: {
        name: ''
      },
      handleSearch: () => {
        getData();
      },
      handleReset: () => {
        tableConfig.paginationConfig.page = 1;
        getData();
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      loading: false,
      paginationConfig: usePageConfig(),
      // isShowHeader: false,
      options: useTableOptions(),
      listName: '终端审核权限',
      headerButtonsList: [{
        label: '新增',
        style: {
          'min-width': '120px'
        },
        func: () => {
          clearData(actionForm.formData);
          actionForm.dialogConfig.title = '新增';
          actionForm.visible = true;
        }
      }],
      columnList: [{
        label: '序号',
        prop: 'serial',
        width: 100
      }, {
        label: '使用人员名称',
        prop: 'userName'
      }, {
        label: 'SN',
        prop: 'sn'
      }, {
        label: '软件账号',
        prop: 'account'
      }, {
        label: '使用开关',
        prop: 'status',
        cellSlot: true
      }, {
        label: '备注',
        prop: 'remark'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '修改',
          func: row => {
            clearData(actionForm.formData);
            actionForm.dialogConfig.title = '编辑';
            actionForm.formData = { ...row
            };
            actionForm.action = 'edit';
            actionForm.visible = true;
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除所选数据吗?').then(async () => {
              try {
                const res = await deleteTerminalCheckApi(row.id);

                if (res.code == '0') {
                  elMessage('success', '删除成功');
                  getData();
                }
              } catch (error) {}
            });
          }
        }]
      }]
    });

    const validatorSn = (rule, value, callback) => {
      if (!actionForm.formData.sn && !actionForm.formData.account) {
        return callback(new Error(t('SN号和软件账号二选一填写')));
      } else if (value && String(value).trim() === '') {
        callback(new Error(t('输入不能为空格')));
      }

      callback();
    };

    const validatorAccount = (rule, value, callback) => {
      if (!actionForm.formData.sn && !actionForm.formData.account) {
        return callback(new Error(t('SN号和软件账号二选一填写')));
      } else if (value && String(value).trim() === '') {
        callback(new Error(t('输入不能为空格')));
      }

      callback();
    };

    const actionForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '使用人员名称',
        prop: 'userName',
        widgetType: 'input',
        maxlength: 64,
        showWordLimit: true,
        required: true
      }], [{
        label: 'SN号',
        prop: 'sn',
        widgetType: 'input',
        input: () => {
          actionForm.formData.account = '';
          formRef.value.mForm.validateField('account');
        },
        maxlength: 15,
        showWordLimit: true
      }], [{
        label: '软件账号',
        prop: 'account',
        widgetType: 'input',
        input: () => {
          actionForm.formData.sn = '';
          formRef.value.mForm.validateField('sn');
        },
        maxlength: 64,
        showWordLimit: true
      }], [{
        label: '备注',
        prop: 'remark',
        widgetType: 'textarea',
        maxlength: 256,
        showWordLimit: true
      }]],
      formData: {
        userName: '',
        sn: '',
        account: '',
        remark: ''
      },
      dialogConfig: {
        title: '新增',
        destroyOnClose: true
      },
      rules: {
        userName: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入使用人员名称'),
          trigger: ['change', 'blur']
        }],
        sn: [{
          required: true,
          validator: validatorSn,
          trigger: ['change', 'blur']
        }],
        account: [{
          required: true,
          validator: validatorAccount,
          trigger: ['change', 'blur']
        }],
        remark: [{
          required: false,
          trigger: ['change', 'blur']
        }]
      },
      confirm: done => {
        formValidator(formRef.value.mForm).then(() => {
          actionForm.action == 'add' ? addData(done) : editData(done);
        }, () => done());
      }
    });
    const currentCid = ref(0);

    const getData = async () => {
      tableConfig.loading = true;

      try {
        const res = await getTerminalCheckApi({
          //cid: currentCid.value,
          keyword: searchConfig.formData.name,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit
        });

        if (res.code == '0') {
          tableConfig.data = res.data.records.map((item, index) => {
            return { ...item,
              serial: index + 1
            };
          });
          tableConfig.paginationConfig.total = res.data.total;
        }
      } catch (error) {
        console.log('238---', error);
      }

      tableConfig.loading = false;
    };

    const addData = async done => {
      try {
        const res = await addTerminalCheckApi({
          cid: currentCid.value,
          ...actionForm.formData,
          status: 0
        });

        if (res.code == '0') {
          actionForm.visible = false;
          elMessage('success', '操作成功');
          done();
          getData();
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    const editData = async done => {
      try {
        const res = await editTerminalCheckApi({
          cid: currentCid.value,
          ...actionForm.formData
        });

        if (res.code == '0') {
          actionForm.visible = false;
          elMessage('success', '操作成功');
          done();
          getData();
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    const handleSwitchChange = row => {
      tableConfig.loading = true;
      return new Promise(async (resolve, reject) => {
        try {
          const res = await switchStatusApi({
            terminalCheckId: row.id,
            status: row.status == 0 ? 1 : 0
          });

          if (res.code == '0') {
            elMessage('success', '操作成功');
            getData();
            return resolve(true);
          } else {
            setTimeout(() => {
              tableConfig.loading = false;
              return reject(false);
            }, 200);
          }
        } catch (error) {
          setTimeout(() => {
            tableConfig.loading = false;
            elMessage('error', '');
            return reject(false);
          }, 200);
        }
      });
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    }; // watch(() => actionForm.visible, (val) => {
    //     if (val) {
    //         clearData(actionForm.formData)
    //     }
    // })


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_common_table, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: getData
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'status' ? (_openBlock(), _createBlock(_component_el_switch, {
            key: 0,
            disabled: false,
            "before-change": () => handleSwitchChange(scope.row),
            "active-value": 0,
            "inactive-value": 1,
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event
          }, null, 8, ["before-change", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options"])])), [[_directive_loading, tableConfig.loading]]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '40%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          ref_key: "formRef",
          ref: formRef,
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('注: SN号和软件账号二选一填写')), 1)]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"])]);
    };
  }

});